<template>
  <section>
    <nav class="breadcrumb mt-2 ml-2" aria-label="breadcrumbs">
      <ul>
        <li><router-link to="/">Home</router-link></li>
        <li class="is-active">
          <a href="#" aria-current="page">URL Shortener</a>
        </li>
      </ul>
    </nav>

    <div class="container">
      <div class="content-wrapper">
        <h2 class="title is-3 has-text-centered mb-4">URL Shortener</h2>

        <div class="intro-section mb-5">
          <p class="has-text-centered">
            A simple way to create shortened URLs. Want to learn how it works?
            Check out my
            <router-link
              to="/blog/post/from-tech-tests-to-tiny-urls"
              class="accent-link"
              >blog post</router-link
            >
            about building this service using AWS Lambda and DynamoDB.
          </p>
        </div>

        <form class="url-form">
          <div class="field">
            <div class="control">
              <input
                v-model="longUrl"
                type="url"
                class="input is-medium"
                placeholder="Enter your URL to shorten, e.g. https://example.com"
              />
            </div>
          </div>
          <div class="field">
            <div class="control">
              <button
                @click.prevent="shortenUrl"
                :disabled="isLoading"
                :class="[
                  'button',
                  'is-primary',
                  'is-medium',
                  'is-fullwidth',
                  { 'is-loading': isLoading },
                ]"
              >
                Shorten URL
              </button>
            </div>
          </div>
        </form>

        <div v-if="shortUrl" class="url-form mt-5">
          <p class="has-text-centered mb-2">Your shortened URL:</p>
          <div class="shortened-url">
            <a :href="shortUrl" target="_blank" class="has-text-primary">{{
              shortUrl
            }}</a>
          </div>
        </div>

        <div v-if="error" class="error-section mt-5">
          <p class="has-text-danger has-text-centered">
            {{ error }}
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from "axios";

export default {
  name: "urlshort",
  data() {
    return {
      longUrl: "",
      shortUrl: "",
      isLoading: false,
      error: "",
    };
  },
  methods: {
    async shortenUrl() {
      if (!this.longUrl) {
        this.error = "Please enter a URL";
        return;
      }

      this.isLoading = true;
      this.error = "";
      this.shortUrl = "";

      try {
        const response = await axios.get(
          `https://6pey0i01dl.execute-api.eu-west-2.amazonaws.com/default/shorten/${this.longUrl}`
        );
        this.shortUrl = response.data.shortUrl;
      } catch (err) {
        this.error = `${err.response.data.message} - Example Format: https://example.com`;
        console.error("Error:", err);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.container {
  max-width: 800px;
  padding: 2rem;
}

.content-wrapper {
  margin-top: 2rem;
}

.intro-section {
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.6;
}

.url-form {
  max-width: 600px;
  margin: 0 auto;
}

.shortened-url {
  background: #f0f5ff;
  padding: 1.5rem;
  border-radius: 8px;
  text-align: center;
  font-size: 1.1rem;
  border: 2px solid #3273dc;
  box-shadow: 0 2px 8px rgba(50, 115, 220, 0.15);
  transition: all 0.3s ease;
}

.shortened-url:hover {
  box-shadow: 0 4px 12px rgba(50, 115, 220, 0.2);
  transform: translateY(-2px);
}

.shortened-url a {
  word-break: break-all;
  color: #3273dc;
  font-weight: 500;
}

.shortened-url a:hover {
  text-decoration: underline;
}

.accent-link {
  color: #3273dc;
  text-decoration: underline;
  font-weight: 500;
}

.accent-link:hover {
  color: #2366d1;
}

.mt-5 {
  margin-top: 2rem;
}

.mt-2 {
  margin-top: 0.5rem;
}

.ml-2 {
  margin-left: 0.5rem;
}

.mb-2 {
  margin-bottom: 0.5rem;
}

.mb-4 {
  margin-bottom: 1.5rem;
}

.mb-5 {
  margin-bottom: 2rem;
}

/* Modern touches */
.input {
  transition: border-color 0.2s ease;
  border: 2px solid #dbdbdb;
}

.input:focus {
  border-color: #3273dc;
  box-shadow: 0 0 0 1px rgba(50, 115, 220, 0.25);
}

.button {
  transition: transform 0.2s ease;
}

.button:not(:disabled):hover {
  transform: translateY(-1px);
}

.error-section {
  animation: fadeIn 0.3s ease-in;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
